import apiClient from "../apiClient";

export function fetchOrdersApi({ page = 1, driverId, outletId, orderId, time } = {}) {
  const params = { page };
  if (driverId) params.driverId = driverId;
  if (outletId) params.outletId = outletId;
  if (orderId) params.orderId = orderId;
  if (time !== undefined) params.time = time;
  return apiClient.get("/admin/payments", { params }).then((res) => res.data);
}
